export function getApiBaseUrl() {
  const env = (import.meta as any).env
  const configured =
    env?.VITE_API_URL ||
    (env?.DEV ? "http://localhost:3333" : window.location.origin)
  const trimmed = String(configured).replace(/\/+$/, "")

  return trimmed.endsWith("/api") ? trimmed : `${trimmed}/api`
}

export async function readApiJson(response: Response, fallbackMessage: string) {
  const body = await response.text()
  const contentType = response.headers.get("content-type") || ""

  if (contentType.includes("text/html") || body.trimStart().startsWith("<!doctype")) {
    throw new Error(
      "The backend API returned an HTML page. Check the production VITE_API_URL or /api proxy."
    )
  }

  let json: any = null
  if (body) {
    try {
      json = JSON.parse(body)
    } catch {
      throw new Error("The backend API returned an invalid JSON response.")
    }
  }

  if (!response.ok) {
    throw new Error(json?.message || fallbackMessage)
  }

  return json
}
